var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"libros-lista"},_vm._l((_vm.libros),function(libro,index){return _c('Libro',{key:index,attrs:{"libro":libro}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }